import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	hideDoneErrorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hideDoneErrorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	hideDoneErrorFlagTitle: {
		id: 'issue-table-hide-done-error-flag-title',
		defaultMessage: 'Hide done preference could not be updated.',
		description: 'Text shown in the error flag when hide done toggle fails to update',
	},
	hideDoneErrorFlagDescription: {
		id: 'issue-table-hide-done-error-flag-description',
		defaultMessage: 'Something went wrong. Please try again.',
		description: 'Text shown in the error flag when hide done toggle fails to update',
	},
});
export default messages;
